import React from "react";
import { AHText, Box, Image, TouchableBox } from "arkh";
import { graphql, useFragment } from "react-relay";

import { WorkspaceTodoStoresGalleryItem_todo$key } from "./__generated__/WorkspaceTodoStoresGalleryItem_todo.graphql";
import { FormattedDateInWorkspace } from "@/src/common/dates/FormattedDate";

export function WorkspaceTodoStoresGalleryItem(props: {
  todo: WorkspaceTodoStoresGalleryItem_todo$key;
  isLast: boolean;
  onPress(todoId: string, storeName: string, timezone: string): void;
  disabled?: boolean;
}) {
  const item = useFragment(
    graphql`
      fragment WorkspaceTodoStoresGalleryItem_todo on Todo {
        store {
          id
          name
          timezone
        }
        status
        id
        subTodos {
          status
        }
        response {
          ... on TodoResponseImage {
            images {
              id
              ...Image_image
            }
          }
        }
        resolvedAtDate {
          ...FormattedDate
        }
      }
    `,
    props.todo
  );

  const images = item.response?.images ?? [];
  return (
    <TouchableBox
      onPress={() => {
        props.onPress(item.id, item.store?.name ?? "", item.store!.timezone);
      }}
    >
      <Box space="medium">
        <Box
          style={{ height: 300, overflow: "hidden" }}
          color="surface"
          cornerRadius="small"
        >
          {images.length > 0 ? (
            <Image
              contentFit="cover"
              image={images[0]}
              type="remote"
              style={{ flex: 1 }}
            />
          ) : null}
        </Box>
        <Box
          style={{
            flexDirection: "row",
            flex: 1,
            justifyContent: "space-between",
          }}
        >
          <AHText
            numberOfLines={2}
            spaceTop="xsmall"
            type="detail"
            color="darkText"
          >
            {item.store?.name}
          </AHText>
          <AHText
            numberOfLines={2}
            spaceTop="xsmall"
            type="detail"
            color="darkText"
          >
            {item.resolvedAtDate ? (
              <FormattedDateInWorkspace date={item.resolvedAtDate} />
            ) : null}
          </AHText>
        </Box>
      </Box>
    </TouchableBox>
  );
}
